import { getSearchInput } from 'gcs-common/slices/channelList/channelListSelectors/getSearchInput';
import { setSearchInput } from 'gcs-common/slices/channelList/channelListSlice';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NewChatButton from '../NewChatButton/NewChatButton';
import ChannelSearchBar from '../SearchBar/ChannelSearchBar/ChannelSearchBar';
import styles from './styles.module.scss';

const CraftsmanChannelSearchInput = ({ className, hideNewChatButton = false, placeholder }) => {
  const dispatch = useDispatch();
  const searchTerm = useSelector(getSearchInput);

  const onSearchInputChange = useCallback(
    (event) => {
      dispatch(setSearchInput({ searchInput: event.target.value }));
    },
    [dispatch],
  );

  return (
    <div className={`${styles.searchWrapper} ${className ?? ''}`.trim()}>
      <ChannelSearchBar
        onChange={onSearchInputChange}
        placeholder={placeholder || 'Kontakte oder Gruppe suchen'}
        value={searchTerm}
      />
      {!hideNewChatButton && <NewChatButton />}
    </div>
  );
};

export default CraftsmanChannelSearchInput;

CraftsmanChannelSearchInput.propTypes = {
  className: PropTypes.object,
  hideNewChatButton: PropTypes.bool,
  placeholder: PropTypes.string,
};
